import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allVMTemplates: [],
  vmTemplate: {},
  vmTemplatesOfRegion: [],
  allRegionsAndCluster: [],
  newVMTemplate: {},
  deleteVMTemplate: {},
  allRegions: [],
  Region: {},
  newRegion: {},
  dataCenterRegion: {},
  deleteRegion: {},
  updateVmTemplate: {},
  deleteRegionData: {},
  error: null,
  isLoading: false,
  allActiveRegions: [],
  addRegionData: null,
  editRegionData: null,
  delete: null,
  attachCompany: [],
  detachCompany: [],
  addCustomerToVMTemplate: {},
  detachCustomerFromVMTemplate: {},
};

const vmTemplateSlice = createSlice({
  name: 'vmTemplate',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true; // state not found
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAttachCompany: (state, action) => {
      state.attachCompany = action.payload;
      state.error = null;
    },
    setDetachCompany: (state, action) => {
      state.detachCompany = action.payload;
      state.error = null;
    },
    setAllVMTemplates: (state, action) => {
      state.allVMTemplates = action.payload;
      state.error = null;
    },
    setVmTemplate: (state, action) => {
      state.vmTemplate = action.payload;
      state.error = null;
    },
    setAllActiveRegions: (state, action) => {
      state.allActiveRegions = action.payload;
      state.error = null;
    },
    setAddDataRegionData: (state, action) => {
      state.addRegionData = action.payload;
      state.error = null;
    },
    setEditRegionData: (state, action) => {
      state.editRegionData = action.payload;
      state.error = null;
    },
    setDeleteRegionData: (state, action) => {
      state.deleteRegionData = action.payload;
      state.error = null;
    },
    setVmTemplatesOfRegion: (state, action) => {
      state.vmTemplatesOfRegion = action.payload;
      state.error = null;
    },
    setNewVMTemplate: (state, action) => {
      state.newVMTemplate = action.payload;
      state.error = null;
    },
    setDeleteVMTemplate: (state, action) => {
      state.deleteVMTemplate = action.payload;
      state.error = null;
    },
    setAllRegions: (state, action) => {
      state.allRegions = action.payload;
      state.error = null;
    },
    setAllRegionsAndCluster: (state, action) => {
      state.allRegionsAndCluster = action.payload;
      state.error = null;
    },
    setNewRegions: (state, action) => {
      state.newRegion = action.payload;
      state.error = null;
    },
    setRegion: (state, action) => {
      state.Region = action.payload;
      state.error = null;
    },
    setDelete: (state, action) => {
      state.delete = action.payload;
      state.error = null;
    },
    setUpdateVmTemplate: (state, action) => {
      state.updateVmTemplate = action.payload;
      state.error = null;
    },
    setResetVmTemplate: () => {
      return initialState;
    },
    setAddCustomerToVMTemplate: (state, action) => {
      state.addCustomerToVMTemplate = action.payload;
      state.error = null;
    },
    setDetachCustomerFromVMTemplate: (state, action) => {
      state.detachCustomerFromVMTemplate = action.payload;
      state.error = null;
    },
  },
});

export const {
  start,
  setReducerError,
  setAttachCompany,
  setDetachCompany,
  setAllVMTemplates,
  setVmTemplate,
  setAddDataRegionData,
  setEditRegionData,
  setDeleteRegionData,
  setVmTemplatesOfRegion,
  setNewVMTemplate,
  setDeleteVMTemplate,
  setAllRegions,
  setNewRegions,
  setRegion,
  setDelete,
  setUpdateVmTemplate,
  setAllActiveRegions,
  setAllRegionsAndCluster,
  setResetVmTemplate,
  setAddCustomerToVMTemplate,
  setDetachCustomerFromVMTemplate,
} = vmTemplateSlice.actions;

export default vmTemplateSlice.reducer;
